import { useMemo } from "react";
import { Divider, Flex, Space, Typography } from "antd";
import { checkUserHasModuleAccess } from "../../../pages/utils/commonUtils";
import { ConfirmAlertModal } from "../../../pages/utils/CommonVessels";
import ContactInfoField from "./ContactInfoField";
import HButton from "../../custom/input/button/Button";
import ShowAllSwitch from "./ShowAllSwitch";
import { DEFAULT_CONTACT_ID } from "../../../pages/ConversationContext";

const { Text, Title } = Typography;

export default function ContactDetails({
  contactId,
  contactData,
  contactDataLoading,
  error,
  fetchContactInfo,
  handleBlockNumber,
  showBlockNumberBtn,
  blockNumberModalOpen,
  setBlockNumberModalOpen,
  blockNumberBtnLoading,
  rolesProperties,
  appProperties,
  scrollableContentRef,
  showSwitch,
  showChatView,
  setShowChatView,
}) {
  const locationDetails = [contactData?.city, contactData?.state, contactData?.country].filter(Boolean).join(", ");
  const contactDetails = useMemo(() => {
    return [
      { iconClass: "contact-mail-icon", contactInfoFieldValue: contactData?.email, emptyDataText: "Not Available" },
      contactData?.phone && {
        iconClass: "contact-phone-icon",
        contactInfoFieldValue: contactData?.phone,
        emptyDataText: "Not Available",
      },
      contactData?.phoneNumber &&
        contactData?.phoneNumber !== contactData?.phone && {
          iconClass: "contact-phone-icon",
          contactInfoFieldValue: contactData?.phoneNumber,
          emptyDataText: "Not Available",
        },
      { iconClass: "organization-icon", contactInfoFieldValue: contactData?.orgName, emptyDataText: "Not Available" },
      { iconClass: "person-icon", contactInfoFieldValue: contactData?.ownerName, emptyDataText: "Unassigned" },
      {
        iconClass: "location-icon",
        contactInfoFieldValue: locationDetails,
        emptyDataText: "Not Available",
      },
    ].filter(Boolean);
  }, [contactData, locationDetails]);

  return (
    <div className="contact-content">
      {contactDataLoading ? (
        <div className="d-flex justify-content-center align-items-center h-100 my-5">
          <div className="actionIconsSprite search-loading"></div>
        </div>
      ) : error && error === "SELECT_CONTACT" ? (
        <div className="d-flex flex-column justify-content-center align-items-center h-100 text-center">
          <Typography.Text type="secondary">Select a contact to view</Typography.Text>
        </div>
      ) : (
        <div id="contact-info-panel-content" className="h-100">
          {contactData ? (
            <Flex vertical justify="space-between" className="contact-scrollable-content h-100" ref={scrollableContentRef}>
              {/* Contact Avatar and Basic Info */}
              <div>
                <Space direction="vertical" size={16} className="w-100 mb-2">
                  {/* Contact Details */}
                  {contactDetails.map((item, index) => (
                    <ContactInfoField
                      key={index}
                      iconClass={item?.iconClass}
                      contactInfoFieldValue={item?.contactInfoFieldValue}
                      emptyDataText={item?.emptyDataText}
                    />
                  ))}
                </Space>
                {showSwitch && contactId && contactId !== DEFAULT_CONTACT_ID && (
                  <div>
                    <Divider className="my-4" />
                    <ShowAllSwitch showChatView={showChatView} setShowChatView={setShowChatView} />
                  </div>
                )}
              </div>
              <div>
                {checkUserHasModuleAccess(rolesProperties?.currentRoleDetails, "Blocked Numbers") &&
                  contactData?.phoneNumber &&
                  showBlockNumberBtn && (
                    <>
                      <ConfirmAlertModal
                        titleContent="Block this number?"
                        modalContent={`It will be removed from your Inbox and won't be able to send or receive messages or calls. You can unblock it anytime from Settings → Blocked Numbers.`}
                        buttonConfirm="Block"
                        buttonClassName="hs-bg-red hs-color-white"
                        onConfirm={() => {
                          handleBlockNumber(contactData?.phoneNumber);
                        }}
                        buttonType="danger"
                        onCancel={() => {
                          setBlockNumberModalOpen(false);
                        }}
                        centered={true}
                        open={blockNumberModalOpen}
                        alertIcon={<div className="staticIconsSprite block-modal-icon-red" />}
                      />
                      <HButton
                        variant="danger"
                        size="s"
                        buttonClassName="me-2 w-100"
                        data-cy="block-number-btn"
                        prefixIcon={<div className="actionIconsSprite block-icon-red"></div>}
                        onClick={() => {
                          setBlockNumberModalOpen(true);
                        }}
                        loading={blockNumberBtnLoading}
                      >
                        <span className="hs-fs-12 hs-fw-500 hs-color-red">Block</span>
                      </HButton>
                    </>
                  )}
              </div>
            </Flex>
          ) : (
            <div className="d-flex justify-content-center align-items-center h-100">
              <Text type="secondary">No contact selected</Text>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
